import { Link } from "react-router-dom";
import { ArrowLeft, Users, Target, Zap, Shield } from "lucide-react";
import { useLocale } from "@/contexts/LocaleContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

const About = () => {
  const { locale } = useLocale();
  const isPt = locale.language === "pt";

  const values = [
    {
      icon: Target,
      title: isPt ? "Transparência" : "Transparency",
      description: isPt
        ? "Todas as previsões e resultados são públicos e verificáveis."
        : "All predictions and outcomes are public and verifiable.",
    },
    {
      icon: Users,
      title: isPt ? "Comunidade" : "Community",
      description: isPt
        ? "Construímos uma comunidade de usuários apaixonados por previsões."
        : "We build a community of users passionate about predictions.",
    },
    {
      icon: Zap,
      title: isPt ? "Inovação" : "Innovation",
      description: isPt
        ? "Utilizamos tecnologia de ponta para criar a melhor experiência."
        : "We use cutting-edge technology to create the best experience.",
    },
    {
      icon: Shield,
      title: isPt ? "Segurança" : "Security",
      description: isPt
        ? "Seus dados e CallyCoins estão sempre protegidos."
        : "Your data and CallyCoins are always protected.",
    },
  ];

  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main className="container mx-auto px-4 py-24">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-muted-foreground hover:text-foreground mb-8 transition-colors"
        >
          <ArrowLeft size={18} />
          {isPt ? "Voltar" : "Back"}
        </Link>

        <div className="max-w-3xl mx-auto">
          <h1 className="text-4xl font-bold text-foreground mb-6">
            {isPt ? "Sobre o Callyout" : "About Callyout"}
          </h1>

          <div className="prose prose-invert max-w-none">
            <p className="text-lg text-muted-foreground mb-8">
              {isPt
                ? "Callyout é uma plataforma de mercado de previsões onde você pode fazer previsões em eventos do mundo real usando CallyCoins, nossa moeda virtual. Acreditamos que a sabedoria coletiva pode prever o futuro melhor do que qualquer indivíduo."
                : "Callyout is a prediction market platform where you can make predictions on real-world events using CallyCoins, our virtual currency. We believe that collective wisdom can predict the future better than any individual."}
            </p>

            <h2 className="text-2xl font-semibold text-foreground mb-4">
              {isPt ? "Nossa Missão" : "Our Mission"}
            </h2>
            <p className="text-muted-foreground mb-8">
              {isPt
                ? "Nossa missão é democratizar o acesso aos mercados de previsão, permitindo que qualquer pessoa participe e contribua para a inteligência coletiva. Queremos criar um ambiente divertido, justo e transparente para todos os usuários."
                : "Our mission is to democratize access to prediction markets, allowing anyone to participate and contribute to collective intelligence. We want to create a fun, fair, and transparent environment for all users."}
            </p>

            <h2 className="text-2xl font-semibold text-foreground mb-6">
              {isPt ? "Nossos Valores" : "Our Values"}
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
            {values.map((value) => (
              <div
                key={value.title}
                className="glass-card p-6 flex gap-4"
              >
                <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center shrink-0">
                  <value.icon size={24} className="text-primary" />
                </div>
                <div>
                  <h3 className="font-semibold text-foreground mb-1">
                    {value.title}
                  </h3>
                  <p className="text-sm text-muted-foreground">
                    {value.description}
                  </p>
                </div>
              </div>
            ))}
          </div>

          <div className="prose prose-invert max-w-none">
            <h2 className="text-2xl font-semibold text-foreground mb-4">
              {isPt ? "Como Funciona" : "How It Works"}
            </h2>
            <p className="text-muted-foreground mb-4">
              {isPt
                ? "Na Callyout, você recebe CallyCoins ao criar sua conta. Use esses tokens para fazer previsões em eventos de esportes, política, tecnologia, entretenimento e muito mais. Quando o evento é resolvido, os vencedores dividem o pool de previsões proporcionalmente."
                : "At Callyout, you receive CallyCoins when you create your account. Use these tokens to make predictions on sports, politics, technology, entertainment events and more. When the event is resolved, winners split the prediction pool proportionally."}
            </p>
            <p className="text-muted-foreground">
              {isPt
                ? "Quanto mais você acerta, mais CallyCoins você ganha. Suba no ranking e mostre suas habilidades de previsão para toda a comunidade!"
                : "The more you get right, the more CallyCoins you earn. Climb the leaderboard and show your prediction skills to the entire community!"}
            </p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default About;